var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1137.49,449.4,964.76,329.59v-93A51.78,51.78,0,0,0,913.91,184H755L651.57,112.17a87.92,87.92,0,0,0-102.8,0L444.91,184.64H286.08a51.8,51.8,0,0,0-50.85,52.54v92.88L62.5,449.39v560.33a94.81,94.81,0,0,0,94.7,94.7h885.48a94.83,94.83,0,0,0,94.82-94.7ZM964.76,395.53l79.24,55-79.24,58ZM580.05,155.89a34.29,34.29,0,0,1,40.23,0l39.62,27.54H540Zm-290.61,202V238.15H910.53V548L619.79,760.42a33.66,33.66,0,0,1-39.49,0L289.43,548.08Zm-54.23,37.69V508.47l-79.23-58Zm848,611.74a42.6,42.6,0,0,1-34,41.71,24.45,24.45,0,0,1-5.86.78c-.26,0-.5,0-.75,0H153.56l.29-.21a42.59,42.59,0,0,1-37.07-39.93l-.07,0V489l399.21,291.8,32.13,23.44h0a88,88,0,0,0,103.26,0l34.18-25,397.75-290.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEmail);
export default __webpack_public_path__ + "static/media/open-email.d7e3d9bc22fd4888c02dd0dff9a8fd9c.svg";
export { ForwardRef as ReactComponent };